import {ActionPerformer} from "./ActionPerformer";
import {processGUIActionResult} from "../actions/BaseDispatcher";
import * as notifier from "../common/ErrorsNotification";
import * as NamaURLS from "../constants/NamaURLS";

import {ajaxJSONWithTask} from "../common/NamaCommon";
import {translateId} from "../common/Translator";
import {CustomReportLauncherMenuItem} from "../views/edit/CustomReportLauncherMenuItem";


export class GuiActionPerformer extends ActionPerformer {
    /**
     *
     * @param {ActionPlaceholder} actionPlaceHolder
     * * @param {EditPresenter} presenter
     */
    runCustomAction(actionPlaceHolder, presenter, metaData) {
        if (actionPlaceHolder.getCustomization().reportInfo.reportId) {
            new CustomReportLauncherMenuItem(presenter, actionPlaceHolder.getCustomization().reportInfo).execute();
            return;
        }
        if (presenter.isRecordNotSaved()) {
            notifier.showError(translateId("recordMustBeSaved"));
            return;
        }
        /*
       /**
        * @type {namaTypes.PerformActionReq}
        */
        let reqData = {};
        reqData.actionInfo = actionPlaceHolder.customization;
        let targetRecords = [];
        /*
        /**
         * @type {namaTypes.EntityReferenceData}
         */
        let entityReferenceData = {};
        entityReferenceData.entityType = presenter.entityType;
        entityReferenceData.id = presenter.record.id;
        targetRecords.push(entityReferenceData);
        reqData.targetRecords = targetRecords;
        ajaxJSONWithTask(NamaURLS.PERFORM_Custom_action, {request: JSON.stringify(reqData)}, (guiActionResult) => {
            let result = guiActionResult.data;
            processGUIActionResult(result, presenter, -1, metaData);
        });
    }
}